import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import axiosInstance from 'src/utils/axios';

const useNotificationTypesQuery = (contactMethodId: string | null) =>
  useQuery<number[]>({
    queryKey: queryKeys.client.notificationTypes(contactMethodId),
    queryFn: async () => {
      if (!contactMethodId) throw new Error('contactMethodId required');
      const res = await axiosInstance.get<number[]>(
        api.getNotificationTypes(contactMethodId)
      );
      return res.data;
    },
    enabled: Boolean(contactMethodId),
  });

export default useNotificationTypesQuery;
